<template>
  <section class="section section-calculator">
    <div class="container">
      <div class="content">
        <div class="columns is-centered">
          <div class="column is-narrow">
            <figure class="image">
              <img src="./../assets/img/icons/icon_calculator.png">
            </figure>
          </div>
        </div>
        <a name="downcalculator" id="downcalculator"></a>
        <h2 class="has-text-centered">Ihr Autostrom - Ihre CO<sub>2</sub>-Ersparnis</h2>
        <h3 class="has-text-centered">Zuhause Tanken und losfahren mit dem Strom der Grünen Sradtwerke</h3>
        <div class="calculator-wrapper">
          <div class="columns row-border-bottom has-margin-bottom has-text-centered">
            <div class="column">
              <h4 class="">Elektroauto</h4>
            </div>
            <div class="column">
              <h4 class="">Konventionelles Auto</h4>
            </div>
            <div class="column">
              <h4 class="">Allgemein</h4>
            </div>
          </div>
          <div class="columns row-border-right has-text-centered">
            <div class="column">
              <div class="field" id="selectCar">
                <label class="label">Elektroauto wählen (optional)</label>
                <div class="control has-text-centered">
                  <div class="select is-fullwidth">
                    <select v-model="eCarModelConsumption" name="" @change="setConsumption()" id="">
                      <option value="" selected>Bitte Elektroauto wählen</option>
                      <option v-for="(car, index) in eCars" :value="car.Consumption" :key="index">{{car.Model}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Verbrauch in kWh/100km</label>
                <div class="control has-text-centered">
                  <input v-model="eCarConsumption" v-tooltip.bottom="consumptionTooltip" class="input" type="number" placeholder="3.2">
                </div>

              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Kraftstoff*</label>
                <div class="control has-text-centered">
                  <!-- Rectangular switch -->
                  <label class="switch switch-left">
                    <input v-model="fuel" type="radio" value="Benzin">
                    <span class="slider slider-left">Benzin</span>
                  </label>
                  <!-- Rectangular switch -->
                  <label class="switch switch-right">
                    <input v-model="fuel" type="radio" value="Diesel">
                    <span class="slider slider-right">Diesel</span>
                  </label>
                </div>
              </div>
              <div class="field">
                <label class="label">Verbrauch in Liter/100km*</label>
                <div class="control has-text-centered">
                  <input v-model="carConsumption" class="input" type="number" placeholder="3.2">
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Ihre PLZ*</label>
                <div class="control has-text-centered">
                  <input class="input" type="text" placeholder="4000" v-model="plz">
                </div>
              </div>
              <div class="field">
                <label class="label">Fahrleistung im Jahr in km*</label>
                <div class="control has-text-centered">
                  <input v-model="annualMileage" class="input" type="number" placeholder="20.000">
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column"></div>
            <div class="column">
              <div class="field">
                <div class="control has-text-centered">
                  <pulse-loader v-if="calculating" :loading="loader.loading" :color="loader.color" :size="loader.size"></pulse-loader>
                  <button v-else @click="calculate()" class="button is-link">Vergleichen</button>
                </div>
              </div>
            </div>
            <div class="column has-text-right pflichtfeld"><strong>* Pflichtfelder</strong></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  import axios from "axios";
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    name: "Calculator",

    data() {
      return {
        eCars: null,
        eCarConsumption: "",
        eCarModelConsumption: "",
        carConsumption: 3.2,
        fuel: "Benzin",
        annualMileage: null,
        plz: null,

        calculating: false,
        loader: {
          color: '#2942ad',
          size: '10px',
          loading:true
        },
        consumptionTooltip:{
          content:
            'Wenn Sie ein Elektroauto ausgewählt haben, ' +
            'erscheint in diesem Feld der Verbrauch des Fahrzeugs. ' +
            'Sie können diesen Wert auch überschreiben',
          placement: 'bottom-center',
          classes: ['info'],
          targetClasses: ['it-has-a-tooltip'],
          offset: 25,
          delay: {
            show: 500,
            hide: 300,
          },
        },

        error: null,

        strom_ap: 0.2554,
        strom_gp: 6.42,

        costs: {
          conventional: 0,
          electric: 0
        },
      }
    },
    mounted() {
      this.getECars();
      this.updateStatus();
    },
    methods: {
      getECars() {
        let eCarsModels = localStorage.getItem('eCarsModules');

        if (eCarsModels) {
          this.eCars = JSON.parse(eCarsModels).sort((a, b) => a['Model'].toLowerCase() < b['Model'].toLowerCase() ? -1 : 1);

          return;
        }

        axios
          .get('https://ws-dev.elektroautos.de-media-preview.de/elektroautos')
          .then(response => {
            this.eCars = response.data;

            localStorage.setItem('eCarsModules', JSON.stringify(response.data))
          }).catch(error => {
            this.error['axios-elektroautos'] = error;
        });
      },
      updateStatus() {
        this.$root.$on('calculating', data => {
          this.calculating = data;
        });
      },

      calculate() {
        this.calculating = true;

        //let energyCost = this.strom_ap + ( this.strom_gp );
        let fuelCost = this.fuel == "Benzin" ? 1.358 : 1.256;

        this.costs.conventional = this.annualMileage / 100 * this.carConsumption * fuelCost;
        this.costs.electric = (this.annualMileage / 100) * (this.eCarConsumption * this.strom_ap) + this.strom_gp;

        this.costs.co2 = this.annualMileage / 100 * this.carConsumption * (this.fuel == "Benzin" ? 2.65 : 2.37);
        this.costs.consumption = (this.annualMileage / 12 ) / 100 * this.eCarConsumption;

        this.$root.$emit('calculate', this.costs);
        this.$root.$emit('average', this.costs.consumption);

      },

      setConsumption() {

        this.eCarConsumption = this.eCarModelConsumption;

      },
      compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const modelA = a.Model.toUpperCase();
        const modelB = b.Model.toUpperCase();

        let comparison = 0;
        if (modelA > modelB) {
          comparison = 1;
        } else if (modelA < modelB) {
          comparison = -1;
        }
        return comparison;
      }

    },
    components:{
      PulseLoader
    }
  }
</script>

<style>
  .tooltip.info .tooltip-inner {
    background: rgba(50, 115, 220, 0.9);
    color: white;
    padding: 24px;
    border-radius: 5px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, .1);
    max-width: 350px;
  }
  .tooltip.info .tooltip-arrow {
    border-color: rgba(0, 68, 153, .9);
  }
</style>
